import React from 'react';
import { translate } from '@fiverr-private/i18n-react';
import { logger } from '@fiverr-private/obs';
import { LazyComponent } from '@fiverr-private/ui_utils';
import showErrorToast from '../../utils/showErrorToast';

const LazyBookConsultationDrawer = (componentProps) => {
  const lazyImport = () => import(/* webpackChunkName: 'BookConsultationDrawer' */ '.');
  const onError = (error) => {
    logger.error(error, {
      description: 'Failed to lazy load BookConsultationDrawer',
    });
    showErrorToast(translate('consultation.consultation_drawer.loading_error'));
  };

  return (
    <LazyComponent lazyImport={lazyImport} shouldImport={true} componentProps={componentProps} onError={onError} />
  );
};

export default LazyBookConsultationDrawer;
